import AuthAPI from "./auth"

export default (jwt) => new AuthAPI(jwt)
